export default function () {
    return function (input, type) {
        if (input) {
            if (type === 'time') {
                var hoursMinutes = input.split(/[.:]/);
                var hourSection = parseInt(hoursMinutes[0], 10);
                var minSection = parseInt(hoursMinutes[1], 10) > 0
                    ? ':' + parseInt(hoursMinutes[1], 10)
                    : '';

                if (hourSection > 12) {
                    input = (hourSection - 12) + minSection + 'pm';
                } else if (hourSection === 12 && minSection === '') {
                    input = hourSection + 'noon';
                } else if (hourSection === 12 && minSection !== '') {
                    input = hourSection + minSection + 'pm';
                } else {
                    input = hourSection + minSection + 'am';
                }
                return input;
            } else {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                return days[input - 1];
            }
        }
        return null;
    };
};